import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios';
import {Cookies} from 'react-cookie';
import {config} from '../api/config';

const COOKIE_ACCESS_TOKEN = 'sm.at.0';

const cookies = new Cookies();

const isProd = process.env.NODE_ENV === 'production';
const url = isProd ? config.prod.baseUrl : 'http://localhost:5001';
export const apiClient = axios.create({
    baseURL: url + '/api/',
    withCredentials: true,
    headers: {
        Authorization: `Bearer ${cookies.get(COOKIE_ACCESS_TOKEN)}`,
    },
});

const onResponseSuccess = (response: AxiosResponse<any, any>): AxiosResponse<any, any> => {
    const {method, url} = response.config;
    const {status} = response;

    console.info(`🚀 [API] ${method?.toUpperCase()} ${url} | Response ${status}`);

    return response;
};

const onErrorResponse = (error: AxiosError | Error): Promise<AxiosError> => {
    if (axios.isAxiosError(error)) {
        const {message} = error;
        const {method, url} = error.config as AxiosRequestConfig;
        const {status} = (error.response as AxiosResponse) ?? {};

        console.info(`🚨 [API] ${method?.toUpperCase()} ${url} | Error ${status} ${message}`);

        if (status === 401) {
            cookies.remove(COOKIE_ACCESS_TOKEN);
            window.location.href = '/auth/cb?refresh=true';
        }
    } else {
        console.info(`🚨 [API] | Error ${error.message}`);
    }

    return Promise.reject(error);
};

// can add something here to queryListener for 401 events
apiClient.interceptors.response.use(onResponseSuccess, onErrorResponse);
